import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ButtonBuiltInControl} from '../ButtonBuiltInControl';

import {ButtonBorderControlLabels} from './ButtonBorderControlLabels';

/**
 * @description base class including button border modifications logic
 */
export abstract class ButtonBorderBuiltInControl extends ButtonBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_BUTTON].BORDER;
  }

  public getLabels(): ButtonBorderControlLabels | undefined {
    return undefined;
  }
}
